/**
 * Mirror of backend/script_based_scene_split.py — preview only (verbatim grouping).
 */

const SENTENCE_SPAN_RE = /[^\n]+?(?:[.!?…]+|[।॥]+|$)/gu;

const DEFAULT_TARGET_WORDS = 32;
const DEFAULT_MIN_WORDS = 10;
const DEFAULT_MAX_WORDS = 55;

function wordCount(text) {
  const m = String(text || '').match(/\S+/g);
  return m ? m.length : 0;
}

function sentenceUnits(paragraph, paragraphIndex) {
  if (!paragraph || !String(paragraph).trim()) return [];
  const units = [];
  const re = new RegExp(SENTENCE_SPAN_RE.source, SENTENCE_SPAN_RE.flags);
  let match = re.exec(paragraph);
  while (match) {
    const chunk = paragraph.slice(match.index, re.lastIndex);
    if (chunk.trim()) {
      units.push({
        text: chunk,
        wordCount: wordCount(chunk),
        paragraphIndex,
        isParagraphStart: units.length === 0,
        isParagraphEnd: false,
      });
    }
    match = re.exec(paragraph);
  }
  if (!units.length) {
    return [{
      text: paragraph,
      wordCount: wordCount(paragraph),
      paragraphIndex,
      isParagraphStart: true,
      isParagraphEnd: true,
    }];
  }
  units[units.length - 1].isParagraphEnd = true;
  return units;
}

function joinUnits(units) {
  if (!units.length) return '';
  const parts = [];
  let prevPara = units[0].paragraphIndex;
  units.forEach((unit) => {
    if (unit.paragraphIndex !== prevPara && parts.length) parts.push('\n\n');
    parts.push(unit.text);
    prevPara = unit.paragraphIndex;
  });
  return parts.join('').trim();
}

export function splitScriptIntoContextualScenes(
  fullScript,
  {
    targetWords = DEFAULT_TARGET_WORDS,
    minWords = DEFAULT_MIN_WORDS,
    maxWords = DEFAULT_MAX_WORDS,
    maxScenes = 80,
  } = {},
) {
  const text = String(fullScript || '').replace(/\r\n/g, '\n').trim();
  if (!text) return [];

  const paragraphs = text.split(/\n\s*\n+/);
  const units = [];
  paragraphs.forEach((para, pi) => {
    const stripped = para.trim();
    if (!stripped) return;
    units.push(...sentenceUnits(stripped, pi));
  });
  if (!units.length) return [];

  const sceneGroups = [];
  let bucket = [];
  let bucketWords = 0;

  const flush = () => {
    if (bucket.length) {
      sceneGroups.push(bucket);
      bucket = [];
      bucketWords = 0;
    }
  };

  units.forEach((unit) => {
    if (
      unit.isParagraphStart
      && bucket.length
      && bucketWords >= minWords
      && unit.paragraphIndex !== bucket[bucket.length - 1].paragraphIndex
    ) {
      flush();
    }
    if (bucket.length && bucketWords + unit.wordCount > maxWords) flush();
    bucket.push(unit);
    bucketWords += unit.wordCount;
    if (bucketWords >= targetWords) flush();
  });
  flush();

  let scenes = sceneGroups.map(joinUnits).filter((s) => s.trim());
  while (scenes.length > 1 && wordCount(scenes[scenes.length - 1]) < minWords) {
    scenes[scenes.length - 2] = `${scenes[scenes.length - 2]}\n\n${scenes[scenes.length - 1]}`.trim();
    scenes.pop();
  }
  if (!scenes.length) return [text];
  return scenes.slice(0, Math.max(1, maxScenes));
}

/** @deprecated name — use splitScriptIntoContextualScenes */
export function previewStatements(script) {
  return splitScriptIntoContextualScenes(script);
}
